import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import SignInForm from "../ui/SignInForm";

export function LoginPage() {
  return (
    <Card className="w-full gap-5 rounded-3xl border border-border bg-card p-8 shadow-[0_12px_40px_-16px] shadow-mineral-navy/25 ring-1 ring-mineral-gold/20 transition-all duration-300 ease-in-out">
      <CardHeader className="space-y-1.5 pb-2">
        <p className="text-accent mb-1 text-[11px] font-semibold tracking-[0.15em] uppercase">
          ເຂົ້າສູ່ລະບົບ
        </p>
        <CardTitle className="font-heading font-semibold text-card-foreground text-xl tracking-wide">
          ກະລຸນາປ້ອນຂໍ້ມູນຂອງທ່ານ
        </CardTitle>
        <CardDescription className="font-sans text-muted-foreground">
          ໃສ່ອີເມວ ແລະ ລະຫັດຜ່ານຂ້າງລຸ່ມນີ້ <br />
          ເພື່ອເຂົ້າໃຊ້ບັນຊີຂອງທ່ານ
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <SignInForm />
      </CardContent>
    </Card>
  );
}
